import { isEmptyRichText } from 'components/Common/localizedText'
import { declarePackageLanguage, packageOriginal, PLAYER_PACKAGE_FIELDS, playerPackageDraft, writePackage } from './eventPlayerPackage'

// The event's text blocks (ADR 0013) as its editor holds them: the player package and the description, each written once in its original
// language, which the API translates.

// The description, one rich text: what an editor sends of it is its original in its language, never the other variants.
export const DESCRIPTION_FIELDS = [['body', 'Event description', 'rich']]
export const descriptionDraft = (language, body) => ({ originalLanguage: language, [language]: body || '' })
// The original a draft's description holds, as a text block shows it.
export const descriptionOriginal = description => description && { language: description.originalLanguage, content: { body: description[description.originalLanguage] } }
// The draft's description once its author declares another language for the same text, or writes another text.
export const declareDescriptionLanguage = (description, language) => descriptionDraft(language, description[description.originalLanguage])
export const writeDescription = (description, content) => descriptionDraft(description.originalLanguage, content.body)

// The event's text blocks, in the order the pages show them: each its title and fields, its original as the draft holds it, and how its
// author declares the original's language or writes another text.
export const TEXT_BLOCKS = {
  playerPackage: { title: 'Player package', fields: PLAYER_PACKAGE_FIELDS, original: packageOriginal, declare: declarePackageLanguage, write: writePackage },
  description: { title: 'Event description', fields: DESCRIPTION_FIELDS, original: descriptionOriginal, declare: declareDescriptionLanguage, write: writeDescription },
}

// The event's details as its editor starts them, with each text block's original as its author wrote it. An editor left empty saved a
// document, which starts as no text.
export const editableDetails = data => {
  const { playerPackage, description } = data.localizedTexts || {}
  const original = block => block.variants[block.originalLanguage]?.content
  const body = description && original(description)?.body
  return { ...data.details,
    ...(playerPackage ? { playerPackage: playerPackageDraft(playerPackage.originalLanguage, original(playerPackage), data.details.playerPackage?.tShirt) } : {}),
    ...(description ? { description: descriptionDraft(description.originalLanguage, isEmptyRichText(body) ? '' : body) } : {}) }
}

// The details an editor saves. A text block the editor leaves as it was keeps what the details hold: an event that never had a player
// package keeps none, since the API would write `{}` and mark the field changed, and the description stays the text it was saved as.
export const savedDetails = (draft, data) => {
  const editable = editableDetails(data)
  const unchanged = name => JSON.stringify(draft[name]) === JSON.stringify(editable[name])
  const { playerPackage, description, ...rest } = draft
  const keptPackage = data.details.playerPackage === null ? { playerPackage: null } : {}
  const keptDescription = data.details.description === undefined ? {} : { description: data.details.description }
  return { ...rest,
    ...(data.details.playerPackage != null || !unchanged('playerPackage') ? { playerPackage } : keptPackage),
    ...(unchanged('description') ? keptDescription : { description }) }
}
